<button class="close-button" (click)="onNoClick()">
  <span aria-hidden="true">&times;</span>
</button>
<div mat-dialog-title>
  <div class="modal-header">
    <h6 class="pop-up-title">Air freight terms</h6>
  </div>
  <div class="modal-body">
    <div mat-dialog-content>
      <div class="description">
        Dicker Data cannot guarantee that this order will be shipped today as it is after
        2PM EST. If you would still like to ship this order by air, but acknowledge that
        it may not leave until the next business day, please click accept. If you wish to
        choose an alternative shipping method please click decline.
      </div>
    </div>
  </div>
  <div mat-dialog-actions style="display: block;">
    <div class="row" style="margin: auto;">
      <button mat-button cdkFocusInitial class="button button-red button-large" style="margin: 0 auto;"
        (click)="accept()">Accept</button>
    </div>
    <div class="row" style="margin: auto;">
      <a href="javascript:void(0)" class="declineLink" (click)="onNoClick()">Decline</a>
    </div>
  </div>
</div>